import { useContext } from 'react';
import { AccountSwitchContext } from '#/context/AccountSwitchContext';

const useAccountSwitch = () => useContext(AccountSwitchContext);

export default useAccountSwitch;
